import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/discounts/discount-policy/:policyId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    policyId: string;
}
const mutationFn = ({ policyId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { policyId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteDiscountPolicy };
